<template>
  <div id="pricing-strategy-app">
    <v-tabs v-model="tab" background-color="transparent" dark grow>
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="(item, index) in tabs"
        :key="index"
        style="gap: 10px"
        @click="goToTab(index)"
      >
        <v-icon>{{ item.icon }}</v-icon>
        {{ item.text }}
      </v-tab>
    </v-tabs>
    <router-view :key="$route.fullPath" :ref="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "pricing-strategy-app",
  data: () => ({
    tab: 0
  }),
  computed: {
    tabs() {
      const tabs = [];
      if (this.has_permission("pricing_strategy_suggestions")) {
        tabs.push({
          text: this.$t("Recommendations"),
          key: "recommendations",
          icon: "mdi-lightbulb-on-outline",
          path: "recommendations",
          route_name: "pricing_strategy_recommendations"
        });
      }
      tabs.push({
        text: this.$t("Planning"),
        key: "planning",
        icon: "mdi-calendar-outline",
        path: "planning",
        route_name: "pricing_strategy_planning"
      });
      tabs.push({
        text: this.$t("Strategies"),
        key: "strategies",
        icon: "mdi-strategy",
        path: "strategies",
        route_name: "pricing_strategy_strategies",
        children: [
          {
            route_name: "pricing_strategy_strategy_detail"
          }
        ]
      });
      return tabs;
    },
    // Determinar la pestaña activa en función de la ruta actual
    activeTab() {
      const route_name = this.$route.name;
      let tabIndex = this.tabs.findIndex(tab => tab.route_name === route_name);
      if (tabIndex === -1) {
        this.tabs.forEach((tab, index) => {
          if (tab.children) {
            tab.children.forEach(child => {
              if (child.route_name === route_name) {
                tabIndex = index;
              }
            });
          }
        });
      }
      return tabIndex >= 0 ? tabIndex : 0;
    },
    ...mapGetters({
      has_permission: "has_permission"
    })
  },
  methods: {
    goToTab(index) {
      if (this.$route.path.split("/").pop() !== this.tabs[index].path) {
        this.$router.push({
          name: this.tabs[index].route_name
        });
      }
    }
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(index) {
        this.tab = index;
      }
    }
  }
};
</script>
